import { Injectable } from '@angular/core'
import { HttpClient } from '@angular/common/http'
import { OccEndpointsService } from '@spartacus/core'
import { PoUploadAdapter } from '../connectors/po-upload/po-upload.adapter'
import { PoUpload } from '../../models'
import { MbConstants } from '../../shared/mb-constants'

@Injectable({
  providedIn: 'root'
})
export class OccPoUploadAdapter implements PoUploadAdapter {

  constants = MbConstants
  constructor (protected http: HttpClient,
               protected occEndpoints: OccEndpointsService) {
  }

  post (poUploadForm: PoUpload) {
    const formData = new FormData()
    formData.append(this.constants.FIRST_NAME_CODE, poUploadForm?.firstName || '')
    formData.append(this.constants.LAST_NAME_CODE, poUploadForm?.lastName || '')
    formData.append(this.constants.EMAIL_CODE, poUploadForm?.email || '')
    formData.append(this.constants.PHONE_NUMBER_CODE, poUploadForm?.phoneNumber || '')
    formData.append(this.constants.FILE_CODE, poUploadForm?.file || '')

    return this.http.post(this.getEndpoint(), formData)
  }

  protected getEndpoint () {
    return this.occEndpoints.buildUrl('poUpload')
  }
}

